import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'

  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import CreateOrUpdateCourse from '@/components/editor/CreateOrUpdateCourse.vue'

  import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router/composables'
  import useCourse from '@/composables/useCourse'
  import useEditor from '@/composables/useEditor'
  import useI18n from '@/composables/useI18n'

  import { CourseModule } from '@/store/modules/course'
  import { EditorModule } from '@/store/modules/editor'

  import eventBus from '@/main'

  import { v4 as uuidv4 } from 'uuid'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseInfoEditor',
  emits: ['has-course-changes', 'update-training-content'],
  setup(__props) {

  

  const route = useRoute()
  const router = useRouter()
  const { course, currentCourseId, courseModules, routeToFirstCourseModule } = useCourse()

  const hasCourseChanges = ref(false)

  const fetchingCourse = computed(() => {
    if (!EditorModule.editMode) return true

    if (currentCourseId.value && !course.value) return true

    return false
  })

  const courseHasNoModules = computed(() => CourseModule.coursesModuleMap[currentCourseId.value] === undefined)

  const createOrViewModule = () => {
    if (courseModules.value?.length) return routeToFirstCourseModule(currentCourseId.value)
    createModule()
  }

  const createModule = () => {
    router
      .push({
        name: 'CourseModule',
        params: { courseId: currentCourseId.value, moduleId: 'mod-' + uuidv4() },
      })
      .catch(() => {
        return
      })
  }

  const setSubmitAllCourseChanges = () => {
    EditorModule.setSubmitCourseChanges(true)
  }

  const setDiscardAllCourseChanges = () => {
    EditorModule.setDiscardCourseChanges(true)
  }

  const getCourseInfo = () => {
    if (currentCourseId.value && !course.value) {
      CourseModule.getCourse({ courseId: currentCourseId.value }).then((fetchedCourse) => {
        if (fetchedCourse) {
          if (CourseModule.courses) {
            const existingCourse = CourseModule.courses.find((c) => c.id === currentCourseId.value)
            if (!existingCourse) {
              CourseModule.courses.unshift(fetchedCourse)
            }
          }
        }
      })
    }
  }

  onMounted(() => {
    getCourseInfo()

    if (courseHasNoModules.value && currentCourseId.value) {
      CourseModule.getCourseModules(currentCourseId.value)
    }
  })

  // Watch for changes in courseId or course data to refetch when needed
  watch([currentCourseId, () => course.value], ([newCourseId, newCourse]) => {
    if (newCourseId && !newCourse) {
      getCourseInfo()
    }
  })

  // Watch for course modules when course data is available but modules are missing
  watch([() => course.value, courseHasNoModules], ([newCourse, hasNoModules]) => {
    if (newCourse && hasNoModules && currentCourseId.value) {
      CourseModule.getCourseModules(currentCourseId.value)
    }
  })

  onBeforeRouteLeave((_to, _from, next) => {
    const { inEditorMode } = useEditor(route)
    const { translateString } = useI18n()

    if (!inEditorMode) {
      return next()
    }

    if (hasCourseChanges.value) {
      eventBus.$emit('show-modal', {
        modalContentComponent: 'ConfirmationModal',
        modalTitle: translateString('editor.thereAreChanges'),
        modalProps: {
          confirmationText: translateString('editor.saveOrDiscard'),
          cancelButtonText: translateString('editor.discardChanges'),
          okButtonText: translateString('editor.saveAllChanges'),
          showSvgs: true,
          okCallback: (closeCallback: () => void) => {
            setSubmitAllCourseChanges()
            // next()
            if (typeof closeCallback === 'function') closeCallback()
          },
          cancelCallback: () => {
            setDiscardAllCourseChanges()
            // next()
          },
        },
        cssClass: 'confirmation editor',
        modalCloseCallback: (callback: () => void) => {
          if (typeof callback === 'function') callback()
        },
      })
    } else {
      next()
    }
  })

return { __sfc: true,route, router, course, currentCourseId, courseModules, routeToFirstCourseModule, hasCourseChanges, fetchingCourse, courseHasNoModules, createOrViewModule, createModule, setSubmitAllCourseChanges, setDiscardAllCourseChanges, getCourseInfo, computed, onMounted, ref, watch, LoadingSpinner, CreateOrUpdateCourse, onBeforeRouteLeave, useRoute, useRouter, useCourse, useEditor, useI18n, CourseModule, EditorModule, eventBus, uuidv4 }
}

})